module.exports = __webpack_public_path__ + "static/empaques-7354b34dc7c24ad950a3f7a2415e4749.webp";